import { formatFileSize } from '@/shared/lib/formatFileSize';
import { Button } from '@/shared/ui/button';
import { File as FileIcon, X } from 'lucide-react';

interface SelectedFilesListProps {
  files: File[];
  onRemove?: (index: number) => void;
  disabled?: boolean;
}

export function SelectedFilesList({ files, onRemove, disabled = false }: SelectedFilesListProps) {
  if (files.length === 0) return null;

  return (
    <ul className="space-y-2 mt-2">
      {files.map((file, index) => (
        <li
          key={`${file.name}-${file.size}-${index}`}
          className="flex items-center gap-3 p-2 rounded border border-border bg-muted/30"
        >
          <div className="w-8 h-8 rounded-lg bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center shrink-0">
            <FileIcon className="w-4 h-4 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground truncate">{file.name}</p>
            <p className="text-xs text-muted-foreground">{formatFileSize(file.size) ?? '—'}</p>
          </div>
          {onRemove && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="shrink-0 h-8 w-8"
              onClick={() => onRemove(index)}
              disabled={disabled}
              aria-label={`Remove ${file.name}`}
            >
              <X className="w-4 h-4" />
            </Button>
          )}
        </li>
      ))}
    </ul>
  );
}
